<template>
  <SectionContainer
      :colors="colors"
      :background-variant="backgroundVariant"
      :title="title"
      :style="cssVars"
      class="w-full h-full "
      v-if="images.length > 0"
  >
  <div class="relative w-full flex items-center justify-center py-6 px-6" :style="cssVars">
    <GridMany :media="images" :colors="colors" :show-captions="showCaptions" />
  </div>
  </SectionContainer>
  <LightBox ref="light" frosted/>
</template>

<script setup>
import { computed, ref } from 'vue';
import GridMany from "@/components/GridMany.vue";
import LightBox from "@/components/LightBox.vue";
import SectionContainer from "@/components/SectionContainer.vue";

const light = ref(null);

const props = defineProps({
  images: {
    type: Array,
    required: true,
  },
  colors: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  alt: {
    type: String,
    default: 'Gallery image',
  },
  sharable: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
  backgroundVariant: {type: Number, default: 1},
  // Each item's `caption` under its photo (the section's captions switch).
  showCaptions: {type: Boolean, default: false},
});

const cssVars = computed(() => ({
  "--light-variant-1": props.colors.whitest,
  "--light-variant-2": props.colors.lightest,
  "--light-variant-3": props.colors.light,
  "--primary-color": props.colors.primary,
  "--dark-variant-1": props.colors.dark,
  "--dark-variant-2": props.colors.darkest,
  "--link-color": props.colors.accent,
  "--link-hover-color": props.colors.accentDark
}));
</script>
